export default __webpack_public_path__ + "static/media/magicvase.d3b443b4.png";